const SET_RECURRING_ORDER_SUGGESTION =
  'salesIntelligence/SET_RECURRING_ORDER_SUGGESTION';
const fetchForRecurringOrderSuggestion$ =
  'salesIntelligence/fetchForRecurringOrderSuggestion$';
const dismissRecurringOrderSuggestion$ =
  'salesIntelligence/dismissRecurringOrderSuggestion$';
const acceptRecurringOrderSuggestion$ =
  'salesIntelligence/acceptRecurringOrderSuggestion$';
const openRecurringOrderSuggestionsModal$ =
  'salesIntelligence/openRecurringOrderSuggestionsModal$';
const closeRecurringOrderSuggestionsModal$ =
  'salesIntelligence/closeRecurringOrderSuggestionsModal$';
const openRecurringOrderSuggestionsDiscardReasonsModal$ =
  'salesIntelligence/openRecurringOrderSuggestionsDiscardReasonsModal$';
const closeRecurringOrderSuggestionsDiscardReasonsModal$ =
  'salesIntelligence/closeRecurringOrderSuggestionsDiscardReasonsModal$';

export default {
  SET_RECURRING_ORDER_SUGGESTION,
  dismissRecurringOrderSuggestion$,
  acceptRecurringOrderSuggestion$,
  fetchForRecurringOrderSuggestion$,
  openRecurringOrderSuggestionsModal$,
  closeRecurringOrderSuggestionsModal$,
  openRecurringOrderSuggestionsDiscardReasonsModal$,
  closeRecurringOrderSuggestionsDiscardReasonsModal$,
};
